import { ADMIN_SECTIONS, type AdminSection } from './adminDashboardModel';

const sectionConfig: Record<AdminSection, { icon: string; label: string }> = {
  Dashboard: { icon: '📊', label: 'Dashboard' },
  General: { icon: '⚙️', label: 'General Settings' },
  Radios: { icon: '📡', label: 'Radios' },
  Groups: { icon: '📢', label: 'Groups' },
  Users: { icon: '👥', label: 'Users' },
  ActivityLogs: { icon: '📋', label: 'Activity Logs' },
  Log: { icon: '🕒', label: 'Operational Log' },
  Recordings: { icon: '🎙️', label: 'Recordings' },
  Conversations: { icon: '💬', label: 'Conversations' },
};

// Admin left sidebar, in ADMIN_SECTIONS order (Dashboard first).
export default function AdminSidebar({ active, onSelect }: { active: AdminSection; onSelect: (section: AdminSection) => void }) {
  return (
    <aside className="sticky top-0 self-start h-full w-56 bg-gray-900 border-r border-gray-700 overflow-y-auto z-20 scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-800">
      <nav className="p-3 space-y-2">
        {ADMIN_SECTIONS.map((id) => (
          <button
            key={id}
            onClick={() => onSelect(id)}
            className={`w-full text-left px-4 py-3 rounded-lg font-medium transition ${
              active === id
                ? 'bg-blue-600 text-white'
                : 'text-gray-300 hover:bg-gray-700'
            }`}
          >
            <span className="mr-2">{sectionConfig[id].icon}</span>
            {sectionConfig[id].label}
          </button>
        ))}
      </nav>
    </aside>
  );
}
